// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function mapData<T extends Record<string, any>>(primaryKey: keyof T, data: T[]) {
  const map: { [key: string]: T } = {};
  return data.reduce((map, item) => Object.assign(map, { [item[primaryKey]]: item }), map);
}
